export const isTaxonomyOfType = (taxonomy, type) => {
  if (!taxonomy || !type) {
    return false;
  }

  return taxonomy.primaryVertical && taxonomy.primaryVertical.name
    ? taxonomy.primaryVertical.name.toLowerCase() === type.toLowerCase()
    : false;
};

export const getVerticalName = (article) => {
  if (!article) {
    return '';
  }

  const { item } = article;

  if (!item) {
    return '';
  }

  // Required, as item can be undefined, and hence object destructuring syntax will not work.
  const taxonomy = item && item.taxonomy;

  const primaryVertical = (taxonomy && taxonomy.primaryVertical && taxonomy.primaryVertical.name) || '';

  return primaryVertical.toLowerCase();
};

export const getVerticalModuleClassName = (vertical) => (vertical && vertical.length > 0 ? `${vertical}-module` : '');
